function initVmShippingWidget() {

  const countdownEl = document.getElementById("vm-countdown");
  const orderDateEl = document.getElementById("vm-order-date");
  const shipDateEl = document.getElementById("vm-ship-date");
  const deliveryDateEl = document.getElementById("vm-delivery-date");

  if (!countdownEl) return;

  // Read values from Shopify Metafields
  const processingDays = parseInt(document.getElementById("vm-processing")?.value || 1);
  const minDeliveryDays = parseInt(document.getElementById("vm-min-delivery")?.value || 3);
  const maxDeliveryDays = parseInt(document.getElementById("vm-max-delivery")?.value || 5);

  function formatDate(date) {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric"
    });
  }

  // Processing = Business Days (Skip Saturday & Sunday)
  function addBusinessDays(date, days) {

    const result = new Date(date);

    while (days > 0) {

      result.setDate(result.getDate() + 1);

      const day = result.getDay();

      if (day !== 0 && day !== 6) {
        days--;
      }

    }

    return result;
  }

  // Delivery = Calendar Days
  function addCalendarDays(date, days) {

    const result = new Date(date);

    result.setDate(result.getDate() + days);

    return result;
  }

  const today = new Date();

  orderDateEl.textContent = formatDate(today);

  // Processing Date
  const shipDate = addBusinessDays(today, processingDays);

  shipDateEl.textContent = formatDate(shipDate);

  // Delivery Date (Calendar Days)
  const deliveryStart = addCalendarDays(shipDate, minDeliveryDays);
  const deliveryEnd = addCalendarDays(shipDate, maxDeliveryDays);

  deliveryDateEl.textContent =
    formatDate(deliveryStart) + " - " + formatDate(deliveryEnd);

  // Countdown
  function updateCountdown() {

    const now = new Date();

    const deadline = new Date();

    deadline.setHours(23, 59, 59, 999);

    const diff = deadline - now;

    const hours = Math.floor(diff / 1000 / 60 / 60);
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    countdownEl.textContent =
      String(hours).padStart(2, "0") + "h " +
      String(minutes).padStart(2, "0") + "m " +
      String(seconds).padStart(2, "0") + "s";
  }

  updateCountdown();

  clearInterval(window.vmCountdownInterval);

  window.vmCountdownInterval = setInterval(updateCountdown, 1000);

}

document.addEventListener("DOMContentLoaded", initVmShippingWidget);
document.addEventListener("shopify:section:load", initVmShippingWidget);

initVmShippingWidget();